// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LongWriteResultUpdate
 */
export interface LongWriteResultUpdate {
  /**
   *
   * @type {number}
   * @memberof LongWriteResultUpdate
   */
  userTargetWordCount?: number
  /**
   *
   * @type {string}
   * @memberof LongWriteResultUpdate
   */
  eventId?: string | null
}

/**
 * Check if a given object implements the LongWriteResultUpdate interface.
 */
export function instanceOfLongWriteResultUpdate(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function LongWriteResultUpdateFromJSON(
  json: any,
): LongWriteResultUpdate {
  return LongWriteResultUpdateFromJSONTyped(json, false)
}

export function LongWriteResultUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LongWriteResultUpdate {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userTargetWordCount: !exists(json, 'userTargetWordCount')
      ? undefined
      : json['userTargetWordCount'],
    eventId: !exists(json, 'eventId') ? undefined : json['eventId'],
  }
}

export function LongWriteResultUpdateToJSON(
  value?: LongWriteResultUpdate | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    userTargetWordCount: value.userTargetWordCount,
    eventId: value.eventId,
  }
}
